import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { DialogService } from '../dialog-service/dialog-service.service';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogFileUploadLoadingComponent } from 'src/app/components/dialog-windows/dialog-file-upload-loading/dialog-file-upload-loading.component';

const SWARM_API = '/proxy/api/v0/fileservice/';

@Injectable({
    providedIn: 'root'
})
export class FileUploadService {
    private filesToUpload: File[];
    private uploadedFileIds: string[];
    public uploadComplete = new EventEmitter<string[]>();
    private loadingSpinnerRef: MatDialogRef<
        DialogFileUploadLoadingComponent,
        any
    >;

    constructor(
        private http: HttpClient,
        private dialogService: DialogService
    ) {
        this.filesToUpload = [];
        this.uploadedFileIds = [];
    }

    public uploadFiles(files: File[]): void {
        this.filesToUpload = [...files];
        let loadingMessage =
            'Ihre Datei wird hochgeladen. Bitte haben Sie einen Moment Geduld.';
        if (files.length > 1) {
            loadingMessage =
                'Ihre Dateien werden hochgeladen. Bitte haben Sie einen Moment Geduld.';
        }
        this.loadingSpinnerRef =
            this.dialogService.openFileUploadLoadingDialog(loadingMessage);
        files.forEach((file) => {
            this.uploadFile(file);
        });
    }

    private uploadFile(file: File): void {
        if (file.size > 12000000) {
            this.openFileTooLargeInfoDialog(file);
            this.removeFileFromArray(file);
            return;
        }
        const fd = new FormData();
        fd.append('file', file, file.name);
        this.http
            .post(SWARM_API + 'file', fd, {
                reportProgress: true,
                observe: 'response',
                responseType: 'text'
            })
            .subscribe(
                (event: HttpResponse<string>) => {
                    const fileId = event.body;
                    this.uploadedFileIds.push(fileId);
                    this.removeFileFromArray(file);
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 413) {
                        this.openFileTooLargeInfoDialog(file);
                    } else if (error.status === 400) {
                        this.dialogService.openInfoDialog(
                            'Datei-Upload fehlgeschlagen',
                            `Die Datei '${file.name}' konnte nicht hochgeladen werden. Bitte kontaktieren Sie den Support.`
                        );
                    } else {
                        this.dialogService.openInfoDialog(
                            'Datei-Upload fehlgeschlagen',
                            `Die Datei '${file.name}' konnte nicht hochgeladen werden. Bitte probieren Sie es erneut.`
                        );
                    }
                    this.removeFileFromArray(file);
                }
            );
    }

    private openFileTooLargeInfoDialog(file: File) {
        this.dialogService.openInfoDialog(
            'Datei-Upload fehlgeschlagen',
            `Die Datei '${file.name}' konnte nicht hochgeladen werden, da sie zu groß ist.`
        );
    }

    private removeFileFromArray(file: File): void {
        const index = this.filesToUpload.indexOf(file);
        if (index > -1) {
            this.filesToUpload.splice(index, 1);
        }
        if (this.filesToUpload.length < 1) {
            this.loadingSpinnerRef.close();
            this.uploadComplete.emit(this.uploadedFileIds);
            this.uploadedFileIds = [];
        }
    }
}
